import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ImageSliderComponent, sliderImg } from 'src/app/shared/components/image-slider/image-slider.component';
import { FetchAdvertisementBannerService } from '../services/fetch-advertisement-banners.service';

@Component({
  selector: 'app-advertisement-banner-display',
  templateUrl: './advertisement-banner-display.component.html',
  styleUrls: ['./advertisement-banner-display.component.scss']
})
export class AdvertisementBannerDisplayComponent {
  constructor() { }



}
